import React from "react";
import { FaPlus } from "react-icons/fa6";

interface AddMoreButtonProps {
  onClick?: () => void;
  buttonText?: string;
  className?: string;
  disabled?: boolean;
}

const AddMore: React.FC<AddMoreButtonProps> = ({
  onClick,
  buttonText = "Add More",
  className,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center  gap-3   font-Mulish text-black font-bold text-[12px] ${className}`}
    >
      <span className="bg-primary p-2 rounded-full">
        <FaPlus className="text-white" />
      </span>

      {buttonText}
    </button>
  );
};

export default AddMore;
